import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "d-flex align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_7 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_8 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_9 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_10 = {
  key: 1,
  class: "py-5 text-center"
}
const _hoisted_11 = { class: "fs-18 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_BadgeItem = _resolveComponent("BadgeItem")
  const _component_DialogAddBadge = _resolveComponent("DialogAddBadge")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("AppResourceEP.Badges")), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"240px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAddBadge(_ctx.BadgeType.resident)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_6, [
                        _createVNode("span", _hoisted_7, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                require('@/assets/images/entrancePlants/icon-resident.svg')
                                            ,
                            "aria-label": "icon-resident"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t(
                                                "AppResourceEP.ToResidentActionMenu"
                                            )), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ElDropdownItem, {
                    disabled: !_ctx.hasEligibleGuests,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAddBadge(_ctx.BadgeType.guest)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_8, [
                        _createVNode("span", _hoisted_9, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                require('@/assets/images/entrancePlants/icon-guest.svg')
                                            ,
                            "aria-label": "icon-guest"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t(
                                                "AppResourceEP.ToGuestActionMenu"
                                            )), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                class: "p-button-rounded p-button-raised p-button--m"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.BadgeAdd")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.hasBadges)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.badges, (badge, index) => {
          return (_openBlock(), _createBlock(_component_BadgeItem, {
            key: index,
            disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
            badge: badge,
            class: "mt-3",
            onDeleteBadge: _ctx.handleDeleteBadge
          }, null, 8, ["disabled", "badge", "onDeleteBadge"]))
        }), 128))
      : (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode("h1", null, _toDisplayString(_ctx.$t("entrancePlant.NoBadges").toUpperCase()), 1),
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("entrancePlant.hintNewBadge")), 1)
        ])),
    _createVNode(_component_DialogAddBadge, {
      "is-visible": _ctx.isVisibleAddBadge,
      plantBadges: _ctx.badges,
      guestBadge: _ctx.isGuestBadgeDialog,
      onHideDialog: _ctx.handleAddBadge,
      onUpdateList: _ctx.fetchBadges
    }, null, 8, ["is-visible", "plantBadges", "guestBadge", "onHideDialog", "onUpdateList"])
  ], 64))
}